export default __webpack_public_path__ + "static/media/dole-juice-module-hero-mobile@3x.76747fc4.png";